import { ADMIN_TENANT_ID } from '../config/TenantId';
import { Instant, InstantStore, Trace } from '../metrics';
let shouldEmit = true;
const emitStartupTracesOnce = () => {
    if (!shouldEmit) {
        return false;
    }
    shouldEmit = false;
    const endTime = Date.now();
    Trace('HQReactNativeStartup', ADMIN_TENANT_ID, {
        startTime: InstantStore.timeOf(Instant.ReactNativeViewPresented),
        endTime,
    }).log();
    Trace('HQNativeStartup', ADMIN_TENANT_ID, {
        startTime: InstantStore.timeOf(Instant.ProcessStart),
        endTime: InstantStore.timeOf(Instant.ReactNativeViewPresented),
    }).log();
    Trace('HQFullStartup', ADMIN_TENANT_ID, {
        startTime: InstantStore.timeOf(Instant.ProcessStart),
        endTime,
    }).log();
    return true;
};
export default emitStartupTracesOnce;
//# sourceMappingURL=emitStartupTracesOnce.js.map